var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('button',{on:{"click":_vm.paypalMe}},[_vm._v(" Support TaskBoard via PayPal "),_c('i',{staticClass:"fab fa-paypal"})])])}
var staticRenderFns = []

export { render, staticRenderFns }